import { TableRows, Window } from '@mui/icons-material'
import {
  ToggleButton,
  ToggleButtonGroup,
  type ToggleButtonGroupProps,
} from '@mui/material'

type Props = ToggleButtonGroupProps

export const ResultDisplay = (props: Props) => {
  return (
    <ToggleButtonGroup {...props} exclusive color="info">
      <ToggleButton value="card">
        <Window />
      </ToggleButton>
      <ToggleButton value="grid">
        <TableRows />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
